import { Button } from '@mui/material';
import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import {
  deviceActionButtons,
  getAlertMessage,
  getConfirmationMessage,
  getErrorMessage,
  getTitle
} from '../../../utils/Utilities';
import ConfirmAlertDialog from '../../ConfirmDialog';
import { DeviceActionCommands } from '../../../network/Devices';

const useStyles = makeStyles({
  customDashCard: {
    background: '#FFFFFF',
    boxShadow: '10px 10px 19px 1px #EAEAFF',
    borderRadius: '20px',
    minHeight: '190px'
  },
  textStyle: {
    fontSize: '12px',
    fontWeight: '600',
    lineHeight: '18px',
    textAlign: 'left',
    color: '#7c7d7d',
    textWrap: 'nowrap'
  },
  textStyleMenuItem: {
    fontSize: '12px',
    fontWeight: '600',
    lineHeight: '18px',
    textAlign: 'left',
    color: '#000000'
  },
  sliderInputFields: {
    minwidth: '80px !important',
    width: 'max-content !important',
    height: '8px !important',
    fontSize: '12px !important'
  },
  spanStyle: {
    color: '#171D40',
    fontWeight: '700'
  }
});

export default function DeviceActionPowerSetting({ deviceDetail, setAlertMetas, alertMetas }) {
  const classes = useStyles();
  const [deviceCommand, setDeviceCommand] = useState('');
  const [openConfirmAlertDialog, setOpenConfirmAlertDialog] = useState(false);
  const [confirmAlertDialogMetas, setConfirmAlertDialogMetas] = useState({
    message: '',
    title: '',
    positiveBtnLable: '',
    negativeBtnLabel: ''
  });
  const [responseLoader, setResponseLoader] = useState(false);

  const handleActionPopUp = (url) => {
    setDeviceCommand(url);
    setConfirmAlertDialogMetas({
      ...confirmAlertDialogMetas,
      message: getConfirmationMessage(url),
      title: getTitle(url),
      positiveBtnLable: 'Confirm',
      negativeBtnLabel: 'Cancel'
    });
    setOpenConfirmAlertDialog(true);
  };
  const handleAction = async () => {
    setResponseLoader(true);

    const payload = {
      deviceIds: [deviceDetail.lock_id]
    };

    try {
      const res = await DeviceActionCommands(deviceCommand, payload);
      if (res) {
        setAlertMetas({
          ...alertMetas,
          severity: res?.data?.data[0]?.commandStatus === 'success' ? 'success' : 'error',
          snackBarOpened: true,
          msg:
            res?.data?.data[0]?.commandStatus === 'success'
              ? getAlertMessage(deviceCommand)
              : getErrorMessage(deviceCommand)
        });
        setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
      }
    } catch (error) {
      setAlertMetas({
        ...alertMetas,
        severity: 'error',
        snackBarOpened: true,
        msg: error?.response?.data?.message
      });
      setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
    } finally {
      setResponseLoader(false);
      setOpenConfirmAlertDialog(false);
    }
  };


  return (
    <>
      {deviceActionButtons?.map((item) => (
        <Button
          data-testid="device-power-buttons"
          size="small"
          disabled={
            deviceDetail?.deviceLiveStatus?.toUpperCase() !== 'ONLINE' || deviceDetail?.sleepStatus
          }
          key={item?.id}
          variant="outlined"
          sx={{ m: 0 }}
          onClick={() => handleActionPopUp(item?.url)}
        >
          {item?.btnName}
        </Button>
      ))}
      <ConfirmAlertDialog
        openConfirmAlertDialog={openConfirmAlertDialog}
        message={confirmAlertDialogMetas?.message}
        title={confirmAlertDialogMetas?.title}
        positiveBtnLable={confirmAlertDialogMetas?.positiveBtnLable}
        negativeBtnLable={confirmAlertDialogMetas?.negativeBtnLabel}
        handleClose={() => setOpenConfirmAlertDialog(false)}
        handlePositiveClose={() => {
          handleAction();
        }}
        handleNegativeClose={() => setOpenConfirmAlertDialog(false)}
        isLoading={responseLoader}
      />
    </>
  );
}
